module.exports = __webpack_public_path__ + "img/09_TwispWorks.53b6f7ac.jpg";